import React, {Component} from 'react';
import {connect} from 'react-redux';
import Department from './department';
import * as actions from '../../actions';
import {toJS} from "../hocs/toJs";

const parseDepartment = (department) => {
  return {
    id: department.get('id'),
    name: department.get('name'),
    weightOld: department.get('weightOld'),
    weightNew: department.get('weightNew'),
    weightNewComing: department.get('weightNewComing'),
    createdDate: department.get('createdDate'),
  }
};

class DepartmentHOC extends Component {

  componentDidMount(){
    if(this.props.match.params.id){
      this.props.getDepartmentById({id:this.props.match.params.id})
    }
  }

  parseForm = (formIM) => {
    return {
      name: formIM.get('name'),
      weightOld: formIM.get('weightOld'),
      weightNew: formIM.get('weightNew'),
      weightNewComing: formIM.get('weightNewComing'),
      createdDate: new Date(),
    }
  };

  submitDepartment = (formIM) => {
    const form = this.parseForm(formIM);

    if(this.props.match.params.id){
      delete form.createdDate;
      this.props.updateDepartment({
        id:this.props.match.params.id,
        sendBody: form
      })
    } else {
      this.props.createDepartment({sendBody: form});
    }
  };

  render(){
    return (
      <Department
        {...this.props}
        submitDepartment={this.submitDepartment}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    department: state.department.get('department'),
    loading: state.department.get('fetching') || state.department.get('posting') || state.department.get('updating'),
    message: state.department.get('message')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    createDepartment: (payload) => {
      dispatch(actions.createDepartment(payload))
    },
    getDepartmentById: (payload) => {
      dispatch(actions.getDepartmentById(payload))
    },
    updateDepartment: (payload) => {
      dispatch(actions.updateDepartment(payload))
    },
    changeDepartmentState: (payload) =>{
      dispatch(actions.changeDepartmentState(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(DepartmentHOC));



// WEBPACK FOOTER //
// ./src/components/department/departmentHOC.js